// extracted by mini-css-extract-plugin
export default {"modal":"ix","topline":"jx","img":"kx","textcontents":"lx","heading":"mx","copy":"nx","link":"ox","close":"px","modalinner":"qx","container":"rx"};
    if(module.hot) {
      // 1715276855844
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  